import {
  AccessDenied,
  VerifyingAccess,
  VERIFYINNG_ACCESS_PERMISSION,
  ACCESS_DENIED,
  ACCESS_ALLOWED,
  AccessAllowed,
} from './types'

export const verifyingAccessAction = (): VerifyingAccess => {
  return {
    type: VERIFYINNG_ACCESS_PERMISSION,
    payload: null,
  }
}

export const accessDeniedAction = (): AccessDenied => {
  return {
    type: ACCESS_DENIED,
    payload: true,
  }
}

export const accessAllowedAction = (): AccessAllowed => {
  return {
    type: ACCESS_ALLOWED,
    payload: true,
  }
}
